<template>
  <tr class="delivery-break-row-component text-white bg-dark">
    <td rowspan="2" colspan="10"></td>
    <td class="is-lockable" colspan="4">Pause</td>
    <td class="is-lockable">
      <time-picker v-model="breakStart" :tabindex="100 * (tripIndex + 1) - 3" :disabled="!breakStart" />
    </td>
    <td class="is-lockable">
      <duration-picker v-model="breakDuration" :tabindex="100 * (tripIndex + 1) - 2" />
    </td>
    <td class="is-lockable">
      <time-picker v-model="breakEnd" :tabindex="100 * (tripIndex + 1) - 1" :disabled="!breakStart" />
    </td>
    <td class="is-lockable" colspan="3"></td>
  </tr>
</template>
  
<script>
import { ref, computed } from 'vue'
import emitter from '../mitt';
import moment from 'moment/moment';
import TimePicker from './TimePicker.vue';
import DurationPicker from './DurationPicker.vue';
import { useRouteDataStore } from '../stores/route-data';

export default {
  components: { DurationPicker, TimePicker },
  props: {
    trip_name: {
      type: String,
      required: true,
    },
    last_order: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const routeDataStore = useRouteDataStore();

    const id = computed(() => {
      return `${props.trip_name}_break`;
    });

    const breakStart = computed({
      get() {
        const endId = `${props.trip_name}_end`;
        if (
          props.last_order.deliveryEnd && 
          routeDataStore.routeData.drive_durations[endId] && 
          routeDataStore.routeData.service_durations[endId]
        ) {
          return moment(props.last_order.deliveryEnd, 'HH:mm').add(routeDataStore.routeData.drive_durations[endId] + routeDataStore.routeData.service_durations[endId], 'minutes').format('HH:mm');
        } else {
          return null;
        }
      },
      set(newValue) {
        const diff = moment(newValue, 'HH:mm').diff(moment(breakStart.value, 'HH:mm'), 'minutes');
        props.last_order.deliveryEnd = moment(props.last_order.deliveryEnd, 'HH:mm').add(diff, 'minutes').format('HH:mm');
      }
    });

    const breakDuration = computed({
      get() {
        if (Object.hasOwn(routeDataStore.routeData.service_durations, id.value)) {
          return routeDataStore.routeData.service_durations[id.value];
        } else {
          return 0;
        }
      },
      set(newValue) {
        const diff = newValue - breakDuration.value;
        routeDataStore.routeData.service_durations[id.value] = newValue;
        if (diff > 0) {
          emitter.emit('order-move-down', { id: props.last_order.id, trip_name: props.last_order.route_code, value: props.last_order.deliveryEnd, prev_value: props.last_order.deliveryEnd });
        }
      }
    });

    const breakEnd = computed({
      get() {
        if (breakStart.value && breakDuration.value !== null) {
          return moment(breakStart.value, 'HH:mm').add(breakDuration.value, 'minutes').format('HH:mm');
        } else {
          return null;
        }
      },
      set(newValue) {
        const diff = moment(newValue, 'HH:mm').diff(moment(breakEnd.value, 'HH:mm'), 'minutes');
        props.last_order.deliveryEnd = moment(props.last_order.deliveryEnd, 'HH:mm').add(diff, 'minutes').format('HH:mm');
      }
    });

    const tripNames = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
    const tripIndex = computed(() => {
      return tripNames.indexOf(props.trip_name);
    });

    return {
      breakStart,
      breakDuration,
      breakEnd,
      tripIndex,
    };
  }
}
</script>

<style lang="scss" scoped>
.delivery-break-row-component {  
  td {
    vertical-align: middle;
  }
}
</style>